var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1764.89 2398.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eadfca;}.cls-2{fill:#fef6df;}.cls-3{fill:none;}.cls-4{fill:#f4ead3;}.cls-5{isolation:isolate;}.cls-6{fill:#68c0f1;}.cls-6,.cls-7{opacity:0.5;}.cls-7{fill:#a9e4ff;}.cls-8{clip-path:url(#clip-path);}.cls-9{clip-path:url(#clip-path-2);}.cls-10{clip-path:url(#clip-path-3);}.cls-11{fill:#a09680;}.cls-12{fill:#fff;}.cls-13{clip-path:url(#clip-path-4);}.cls-14{clip-path:url(#clip-path-5);}.cls-15{clip-path:url(#clip-path-6);}.cls-16,.cls-17{opacity:0.2;mix-blend-mode:multiply;}.cls-16{fill:url(#linear-gradient);}.cls-17{fill:url(#linear-gradient-2);}.cls-18{clip-path:url(#clip-path-7);}.cls-19{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(1216.38 1383.28)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 18.16 211.81 39.74 411.94 10.58 221.58 103.76 30.43 39.37 0 18.16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(1216.38 1383.28)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "148.53 55.26 212.47 0 213.89 71.58 148.53 55.26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(1216.38 1383.28)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "212.47 0 270.77 54.07 213.89 71.58 212.47 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(1216.38 1383.28)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.89 71.58 0 18.16 114.13 153.43 213.89 71.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(1216.38 1383.28)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.89 71.58 411.94 10.58 316.23 150.19 213.89 71.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(1216.38 1383.28)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "213.89 71.58 114.13 153.43 215.18 151.81 316.23 150.19 213.89 71.58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1407.33,
    y1: 1358.55,
    x2: 1388.93,
    y2: 1496.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#a8a9aa",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#505253",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 226.3,
    y1: -24.61,
    x2: 207.82,
    y2: 114.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 1675.21, 1383.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(1216.38 1383.28)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119,137.91a31.62,31.62,0,0,1,16.86.36c8.11,2.63,15.24,11.33,23.72,12.33,7.91.93,18.72-1.63,26.59-3.08,25.12-4.63,56.1-22,81.39-18.36,14.94,2.14,22.83,15.11,37.89,14.07,14.08-1,26.66-9.36,40.59-11.67,8.65-1.43,19.73,1.23,21.76,9.76a14,14,0,0,1-1.69,9.83c-4.71,8.58-14.87,12.4-24.33,14.88-71.42,18.64-146.71-1-220.5.25-5.89.11-34,1.56-34.75-8.16-.5-6.58,21-16.16,25.91-18.14A43.84,43.84,0,0,1,119,137.91Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -322.34,
    y1: -1406.99,
    x2: -340.6,
    y2: 1116.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#b2e8fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73c4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#41a8ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1e93e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0887e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082e2"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.92,128.56c-.35,0-.28-.59.06-.59s.28.59-.06.59",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110,134.22a3.23,3.23,0,0,1-2.35-1.13,2.67,2.67,0,0,1-.58-1.25,3.09,3.09,0,0,1-.12-1.49c.09-.34.17-.68.25-1a4.73,4.73,0,0,1,1.11-1.7l.78-.6a3.57,3.57,0,0,1,1.82-.52,2.27,2.27,0,0,1,1.31.33,2.33,2.33,0,0,1,1,.79,2.59,2.59,0,0,1,.58,1.24,2.93,2.93,0,0,1,.13,1.48l-.24,1a4.7,4.7,0,0,1-1.1,1.71l-.78.6a3.55,3.55,0,0,1-1.84.53",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.05,129.17c-2.27,0-1.84-3.87.43-3.87s1.85,3.87-.43,3.87",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.79,132.24l-.1.11-.6.47-.68.3a2.31,2.31,0,0,1-1.74-.15,2.21,2.21,0,0,1-1-.92,2.8,2.8,0,0,1-.36-1.8A3.67,3.67,0,0,1,107,127.7a2.63,2.63,0,0,1,1.75-.35,2.08,2.08,0,0,1,1.45.81l.07.11a2.79,2.79,0,0,1,.52,2l-.18.75a3.42,3.42,0,0,1-.81,1.24",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.28,130.73c0-.13.1-.27.16-.4l-.07.5a1.55,1.55,0,0,1,.88-1.55,1.58,1.58,0,0,1,1.22-.28.79.79,0,0,1,.48.86,2,2,0,0,1-.68,1.18,1.42,1.42,0,0,1-.65.47,1,1,0,0,1-.92-.12l.41.13-.38,0c-.38,0-.6-.42-.45-.81",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.87,129.29h-.07l.61-.09h0a1.69,1.69,0,0,1-.94,0,1.13,1.13,0,0,1-.32,0,1.55,1.55,0,0,1-.74-.46,1.6,1.6,0,0,1-.52-.72c-.06-.21-.11-.42-.16-.63,0,.21.1.41.16.61a.14.14,0,0,1,0-.07,1.66,1.66,0,0,1-.16-.6c0-.22,0-.44,0-.66a1.32,1.32,0,0,1,.08-.33,2.25,2.25,0,0,1,.38-.92,2.79,2.79,0,0,1,.92-.89c.1-.05.49-.23.59-.26a5.82,5.82,0,0,1,.68-.1,1.5,1.5,0,0,1,.88.22,1.53,1.53,0,0,1,.7.54,1.7,1.7,0,0,1,.39.82,2,2,0,0,1,.09,1v0a.13.13,0,0,0,0,.06c0,.09-.13.58-.16.67v0l-.29.58a2.05,2.05,0,0,1-.64.67,1.17,1.17,0,0,1-.52.31,1.7,1.7,0,0,1-.87.21",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.82,127.76h.06l-.59.09.09,0-.57.25a2.55,2.55,0,0,1,1.23-.35,2,2,0,0,1,1.14.36l-.5-.25.12,0-.57-.08h.12l-.57.08.39-.07a1.06,1.06,0,0,1,.56,0,.84.84,0,0,1,.49.15.61.61,0,0,1,.23.11l-.45-.22h0l-.48-.07h0l-.47.07h0l-.42.19h0l-.35.27h0l-.28.33h0l-.18.36c.34-.68.54-1.17,1.64-1.18a1.49,1.49,0,0,1,.47.07,1.73,1.73,0,0,1,1.06,1,2.77,2.77,0,0,1-.37,2.47,3.07,3.07,0,0,1-.5.58,2.67,2.67,0,0,1-1.77.79,2.09,2.09,0,0,1-1.93-1.37,2.59,2.59,0,0,1,.3-2.39,2.51,2.51,0,0,1,2-1.17",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.13,130.17a5.43,5.43,0,0,1-.72-.1,1.67,1.67,0,0,1-.79-.57c-.11-.14-.2-.29-.31-.43a1.28,1.28,0,0,1,.19-1.61l.4-.42a2.07,2.07,0,0,1,.92-.56,4.55,4.55,0,0,1,.74-.11,1.45,1.45,0,0,1,1.16.56,1.85,1.85,0,0,1,.36,1.34,2.28,2.28,0,0,1-.66,1.34,1.78,1.78,0,0,1-1.29.56",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.67,131.77a2.58,2.58,0,0,1-1.28-1.07,1.36,1.36,0,0,1,.23-1.74,3.87,3.87,0,0,1,1.55-1.07,1.65,1.65,0,0,1,2.06,1.94,2.18,2.18,0,0,1-2.56,1.94",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95,132.75a1.91,1.91,0,0,1,1.83-1.39,4,4,0,0,1,1.72.1,1,1,0,0,1,.19,1.71,5.55,5.55,0,0,1-2.13,1A1.23,1.23,0,0,1,95,132.75",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.45,132.37a2.29,2.29,0,0,1-1.19.75,3.18,3.18,0,0,1-1.32-.3c-.78-.24-.62-1.56.22-1.8a3.46,3.46,0,0,1,1.38-.29,1.61,1.61,0,0,1,1,.74.69.69,0,0,1-.1.9",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.18,135.62a3.45,3.45,0,0,1-1.55.28,8.26,8.26,0,0,1-1.22-.26c-.91-.24-.8-1.68,0-2.19a7.51,7.51,0,0,1,1.22-.7,3.9,3.9,0,0,1,1.54-.23,1.27,1.27,0,0,1,1.22,1.37,1.87,1.87,0,0,1-1.24,1.73",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.79,134.6a3.77,3.77,0,0,1-.88.1,2.34,2.34,0,0,1-.64-.12c-.07,0-.4-.09-.07,0s0,0,0,0a3.56,3.56,0,0,1-.57-.08c-.19-.05.38,0,.18,0s.41-.1.1,0A1.25,1.25,0,0,1,94.32,133a3.35,3.35,0,0,1,1.54-2.28,2.53,2.53,0,0,1,2.91-.07,2,2,0,0,1,.65,2.14,2.48,2.48,0,0,1-1.63,1.8",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.79,131.51l.29-.55-.16,1.13,0-.1a2.27,2.27,0,0,1,.44-2.17,1.92,1.92,0,0,1,2-.69h0a1.6,1.6,0,0,1,1,1.8s0,0,0,.06A2.33,2.33,0,0,1,95,132.79a1.55,1.55,0,0,1-1.88-.4l-.06-.07.94.29-.54.09a.64.64,0,0,1-.73-.29.92.92,0,0,1,.07-.9",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.55,129.91a1.82,1.82,0,0,1-.36-1.13,1.65,1.65,0,0,1,.13-.78s0,0,0,0l-.12.51v0a2.85,2.85,0,0,1,.35-1,2.14,2.14,0,0,1,.92-.77,1.53,1.53,0,0,1,.91-.13,1.44,1.44,0,0,1,.93.52,3.23,3.23,0,0,1,.27.44,2,2,0,0,1,.12,1,2.2,2.2,0,0,1-.36,1v0a2,2,0,0,1-1.39.92,1.16,1.16,0,0,1-.69,0,1.44,1.44,0,0,1-.72-.49",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.14,127.56c.4-.59.71-1.25,1.15-1.8a2.27,2.27,0,0,1,2.66-.63,1.09,1.09,0,0,1,0,1.92,4.28,4.28,0,0,1-1.87.7c-.57,0-.91-.26-1.41.32-.32.38-.82-.11-.54-.51",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.28,131l.22-.13-.33.65A3.35,3.35,0,0,1,94.44,129a2.87,2.87,0,0,1,2.81-.41c.79.26,1,1.24.48,2.05a3.49,3.49,0,0,1-2.42,1.92,2.1,2.1,0,0,1-2.11-.94l.56.26-.24.09c-.57.2-.78-.71-.24-1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.11,126.85a3.54,3.54,0,0,1,.65-.57,1.44,1.44,0,0,1,1.89.27l.14.16A1.36,1.36,0,0,1,107,128l-.1.22c-.28.66-1,1.39-1.7,1.29a2.37,2.37,0,0,1-.75-.19,1.27,1.27,0,0,1-.83-1,1.89,1.89,0,0,1,.54-1.46",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107.2,126.3a6.06,6.06,0,0,1,.6-.74,2.27,2.27,0,0,1,1.58-.7,1.56,1.56,0,0,1,1.55,1.43,2.33,2.33,0,0,1-1.09,2.23,5.62,5.62,0,0,1-.56.25,2.45,2.45,0,0,1-1,0c-.18,0,.35,0,.17,0a1,1,0,0,1-.24,0c-1.14.06-1.72-1.46-1-2.49",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.76,127.11a1.65,1.65,0,0,1-1.26-.6,2,2,0,0,1-.38-1.46,2.45,2.45,0,0,1,.72-1.45,2.11,2.11,0,0,1,1.4-.6,1.59,1.59,0,0,1,1.25.6,2,2,0,0,1,.39,1.45,2.51,2.51,0,0,1-.72,1.46,2.11,2.11,0,0,1-1.4.6",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.73,124.77l-.07,0,.31.15a1.71,1.71,0,0,1-.48-.21c-.1-.1-.2-.2-.31-.29a1.28,1.28,0,0,1-.28-.6,1.87,1.87,0,0,1,0-1.21,2.91,2.91,0,0,1,.65-1,1.51,1.51,0,0,1,2.22,0,2.24,2.24,0,0,1,.41,1c0,.16,0,.33,0,.49a1.65,1.65,0,0,1-.23.72,2,2,0,0,1-.79.89,2.17,2.17,0,0,1-.53.21l.34-.15a1.25,1.25,0,0,1-1.3,0",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.21,118.73a43.67,43.67,0,0,1-1.6,4.4,42.83,42.83,0,0,0-2,4.68l-2.19-1.07a15,15,0,0,0,1.75-4.49,1.4,1.4,0,0,1,.89-.87,1.15,1.15,0,0,1,.61,0,1,1,0,0,1,.71.87,9.12,9.12,0,0,1-1.93,5.89c-.9,1.28-2.82.49-2.2-1.07a44.15,44.15,0,0,1,2.23-4.78,14.67,14.67,0,0,1,3.34-3.8.22.22,0,0,1,.36.24",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.22,124.46a2.84,2.84,0,0,1-.53.61,2.1,2.1,0,0,1-1.25.48,1.83,1.83,0,0,1-1.31-.16,1,1,0,0,1-.29-1.13,2.9,2.9,0,0,1,.94-1.2,2,2,0,0,1,1.93-.57c.78.14,1,1.29.51,2",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.37,127.45a2.12,2.12,0,0,1-2.54.07,2,2,0,0,1-.77-1.84,2.67,2.67,0,0,1,1.18-1.81,2.08,2.08,0,0,1,2.56,0,1.62,1.62,0,0,1,.58.73,2,2,0,0,1,.13,1,2.31,2.31,0,0,1-.38,1,2.24,2.24,0,0,1-.76.74",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.33,128.12a2.34,2.34,0,0,1-.3-.25,1.27,1.27,0,0,1-.46-1.16,1.69,1.69,0,0,1,.76-1.16l.35-.25a1.36,1.36,0,0,1,2.07,1.41c-.15,1.21-1.54,2.08-2.42,1.41",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.06,128.79a7,7,0,0,1-1.21,0,.8.8,0,0,1-.76-.62,1.21,1.21,0,0,1,.34-1.11,10.27,10.27,0,0,1,1-.87,1.46,1.46,0,0,1,1.39-.39,1.19,1.19,0,0,1,.78.87,1.72,1.72,0,0,1-1.53,2.1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.87,130.59a2.66,2.66,0,0,1-1.84-.88,1.45,1.45,0,0,1,.26-1.85,3.58,3.58,0,0,1,2.07-.87,1.5,1.5,0,0,1,1.4,1.8,2.09,2.09,0,0,1-1.89,1.8",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.49,127.59l-.14-.15c-1.15-1.17,2.21-1.85,1.09-.15,0,.08-.1.16-.16.24a.51.51,0,0,1-.92,0,2.44,2.44,0,0,1-.1-.24c-.72-1.7,2.47-1,1.06.15l-.18.15a.46.46,0,0,1-.65,0",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109,127.92c-.2,0-.16-.34,0-.34s.16.34,0,.34",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.55,126.46c-3.35,0-2.69-5.67.65-5.67s2.71,5.67-.65,5.67",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.43,126.22a1.66,1.66,0,0,1-1.8.86,1.74,1.74,0,0,1-1-1,1.44,1.44,0,0,1,.36-1.52,1.2,1.2,0,0,1,1.42-.2s-.26-.11-.11-.06-.16,0-.16,0h.12a2.22,2.22,0,0,1,.45,0,1.23,1.23,0,0,1,.45.27.61.61,0,0,1,.21.26c.1.18.11.19,0,0s0-.08,0,0-.23-.19-.08-.08a1.12,1.12,0,0,1,.18,1.49",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105,128.12a2.11,2.11,0,0,1-.88.14,1.6,1.6,0,0,1-1.47-1,2.26,2.26,0,0,1,0-1.56,2.54,2.54,0,0,1,1-1.21,1.8,1.8,0,0,1,1.86,0,1.69,1.69,0,0,1,.59.57,2.07,2.07,0,0,1-1.11,3.06",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.81,128.54a1.31,1.31,0,0,1-.76-.2,1.21,1.21,0,0,1-.59-.46,1.41,1.41,0,0,1-.33-.71,1.76,1.76,0,0,1-.06-.86l.15-.59a2.67,2.67,0,0,1,.65-1l.45-.35a2.08,2.08,0,0,1,1.06-.3,1.9,1.9,0,0,1,1.35.65,1.36,1.36,0,0,1,.32.71,1.61,1.61,0,0,1,.07.85l-.15.59a2.61,2.61,0,0,1-.64,1l-.46.35a2.2,2.2,0,0,1-1.06.31",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.56,125.3a.59.59,0,0,1,0,.08,2.7,2.7,0,0,1,.18,1.33,3.07,3.07,0,0,1-.49,1.33l-.06.08a2.5,2.5,0,0,1-.76.79,1.32,1.32,0,0,1-.61.36,1.92,1.92,0,0,1-1,.25l-.67-.1-.58-.29a1.77,1.77,0,0,1-.63-.72,1.31,1.31,0,0,1-.25-.62,2.17,2.17,0,0,1-.09-1.08c.07-.25.13-.5.19-.74s.22-.45.34-.67a2.44,2.44,0,0,1,.75-.78,1.52,1.52,0,0,1,.61-.36,2,2,0,0,1,1-.24l.66.1.58.28a2.31,2.31,0,0,1,.79,1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.22,131.53a2.5,2.5,0,0,1-1.94-.93,3.09,3.09,0,0,1-.57-2.25,3.79,3.79,0,0,1,1.12-2.24,3.28,3.28,0,0,1,2.14-.92,2.5,2.5,0,0,1,1.93.92,3.08,3.08,0,0,1,.59,2.24,3.89,3.89,0,0,1-1.11,2.25,3.29,3.29,0,0,1-2.16.93",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.63,127.11l0,0-.45-.78-.24-.92a3,3,0,0,1,.12-1.52,4.39,4.39,0,0,1,1.61-2.48,1.91,1.91,0,0,1,.83-.49,2.61,2.61,0,0,1,1.38-.33l.91.14.78.38.64.59.46.77c.08.31.17.61.25.91a3.14,3.14,0,0,1-.11,1.52,2.27,2.27,0,0,1-.35,1,3.34,3.34,0,0,1-.86,1.24l0,0a3,3,0,0,1-1.2.79,2.66,2.66,0,0,1-1.37.32l-.9-.13a3,3,0,0,1-1.41-1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.81,131.72a2,2,0,0,1-1.46-.71,1.5,1.5,0,0,1-.34-.77,1.81,1.81,0,0,1-.06-.93l.16-.64a3,3,0,0,1,.71-1.06,2.52,2.52,0,0,1,1.64-.7,1.34,1.34,0,0,1,.82.2,1.29,1.29,0,0,1,.63.5,1.4,1.4,0,0,1,.35.77,1.81,1.81,0,0,1,.07.93c0,.21-.11.42-.16.64a3,3,0,0,1-.71,1.06,2.48,2.48,0,0,1-1.65.71",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.3,131.54l-.09,0,.4-.17a2.3,2.3,0,0,1-1,.32,1.43,1.43,0,0,1-.86-.26,2.13,2.13,0,0,1-.54-.71l.21.37,0,0a1.79,1.79,0,0,1-.23-1.51,2.32,2.32,0,0,1,1-1.31l.09-.06a1.55,1.55,0,0,1,1.73,0,1.81,1.81,0,0,1,.72,1.33,2,2,0,0,1-1.32,2",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.78,132l.41-.31a2.65,2.65,0,0,1,.26-.21,1,1,0,0,1,.4-.09c.3,0,.49.35.36.65a1.45,1.45,0,0,1-.18.32,1,1,0,0,1-.22.19l-.38.3a.65.65,0,0,1-.4.17.46.46,0,0,1-.36-.17.68.68,0,0,1,.11-.85",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M99.44,131.72c-1,0-.77-1.69.22-1.69s.77,1.69-.22,1.69",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101.7,129.05a1.49,1.49,0,0,1,.42-.41,1.28,1.28,0,0,1,.53-.15l.23,0a.62.62,0,0,1,.56.34.81.81,0,0,1,0,.73,2.56,2.56,0,0,1-.11.24,1.21,1.21,0,0,1-.81.78.78.78,0,0,1-.5,0,.8.8,0,0,1-.43-.36,1.12,1.12,0,0,1,.07-1.14",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108.45,127.42s0,0,0-.06v.42a.07.07,0,0,0,0,0c0,.12.07.24.1.37s0,0,0,0l.18.31,0,0,.26.24,0,0,.31.16a1.21,1.21,0,0,1-.57-.4,1,1,0,0,1-.23-.49,1.24,1.24,0,0,1,0-.58c0-.14.07-.27.1-.4a1.88,1.88,0,0,1,.43-.67l.32-.24.36-.16a1.62,1.62,0,0,1,.2,0l.2,0h0l.37.06a1.2,1.2,0,0,1,.34.16l0,0,.27.25h0a1.18,1.18,0,0,1,.11.19,1.6,1.6,0,0,1,.11.19,1.73,1.73,0,0,1-.19,1.61l-.27.33a1.63,1.63,0,0,1-.69.41,1,1,0,0,1-.58,0,.94.94,0,0,1-.52-.19,1.31,1.31,0,0,1-.46-.58,1.68,1.68,0,0,1-.1-.81",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.74,129.32l.25-.4a.66.66,0,0,1,1.19,0l.15.4a1.11,1.11,0,0,1-.14,1,1.08,1.08,0,0,1-.86.51.78.78,0,0,1-.73-.51,1.11,1.11,0,0,1,.14-1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.59,128a1.43,1.43,0,0,1-1.11-.53,1.76,1.76,0,0,1-.33-1.3,2.22,2.22,0,0,1,.65-1.29,1.9,1.9,0,0,1,1.24-.53,1.46,1.46,0,0,1,1.12.53,1.79,1.79,0,0,1,.33,1.29,2.22,2.22,0,0,1-.65,1.3,1.88,1.88,0,0,1-1.25.53",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.92,129.93c-.12,0-.23,0,.09,0-.24.06.33-.16.11-.05a2,2,0,0,1-1.06.24,3.07,3.07,0,0,1-.52-.06c-.1,0-.72-.31-.2-.08-.11,0-.3,0,.07,0-.21,0,.26-.08,0,0a.92.92,0,0,1-1-.3,1.25,1.25,0,0,1-.13-1.11,2.41,2.41,0,0,1,2.12-1.72,1.49,1.49,0,0,1,1.46.92,2.24,2.24,0,0,1,.16,1.07,1.28,1.28,0,0,1-1.17,1.14",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M98.36,132.13a2.17,2.17,0,0,1-.86.13c-.24,0-.47-.11-.7-.17-.61-.15-.46-1.24.18-1.39a7,7,0,0,1,.74-.16,1.83,1.83,0,0,1,.84.12c.63.18.49,1.29-.2,1.47",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M113.72,127.52c-1.53,2.2-3.8,2.29-6,2.87-3.46.9-6.74,2.09-10.15,3.33-3.93,1.43-7.07,2.56-10.26,6.13-1,1.11-1.07,1.83-2,2.87a1.8,1.8,0,0,1-2.71,0c-4.27-4.9,8.66-11.83,11.53-13.78,4.25-2.89,17-7.54,19.72-2.06a.67.67,0,0,1-.07.64",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1216.38 1401.44 1428.19 1423.02 1628.33 1393.87 1437.96 1487.04 1246.81 1422.66 1216.38 1401.44"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.71,
    y: 17.18,
    width: 0.97,
    height: 90.11,
    transform: "translate(1215.38 1383.31) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.68,
    y: 17.14,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.38 1383.35) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.28,
    y: 17.08,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.38 1383.41) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.88,
    y: 17.03,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.39 1383.46) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.48,
    y: 16.97,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.39 1383.52) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.08,
    y: 16.91,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.39 1383.58) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.68,
    y: 16.85,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.39 1383.64) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.27,
    y: 16.79,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.39 1383.69) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.87,
    y: 16.74,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.39 1383.75) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.47,
    y: 16.68,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.39 1383.81) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.07,
    y: 16.62,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.39 1383.87) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.67,
    y: 16.56,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.4 1383.93) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.27,
    y: 16.51,
    width: 3.6,
    height: 90.11,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.4, 1383.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.87,
    y: 16.45,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.4 1384.04) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.47,
    y: 16.39,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.4 1384.1) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.07,
    y: 16.33,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.4 1384.16) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.67,
    y: 16.28,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.4 1384.21) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.27,
    y: 16.22,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.4 1384.27) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.87,
    y: 16.16,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.41 1384.33) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.46,
    y: 16.1,
    width: 3.6,
    height: 90.11,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.41, 1384.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.06,
    y: 16.04,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.41 1384.44) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.66,
    y: 15.99,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.41 1384.5) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.26,
    y: 15.93,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.41 1384.56) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.86,
    y: 15.87,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.41 1384.62) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.46,
    y: 15.81,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.41 1384.68) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.06,
    y: 15.76,
    width: 3.6,
    height: 90.11,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.42, 1384.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.66,
    y: 15.7,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.42 1384.79) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 95.26,
    y: 15.64,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.42 1384.85) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.86,
    y: 15.58,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.42 1384.91) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 102.46,
    y: 15.52,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.42 1384.96) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 106.06,
    y: 15.47,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.42 1385.02) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 109.65,
    y: 15.41,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.42 1385.08) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.25,
    y: 15.35,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.43 1385.14) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.85,
    y: 15.29,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.43 1385.2) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.45,
    y: 15.24,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.43 1385.25) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.05,
    y: 15.18,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.43 1385.31) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.65,
    y: 15.12,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.43 1385.37) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.25,
    y: 15.06,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.43 1385.43) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.85,
    y: 15.01,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.43 1385.48) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 138.45,
    y: 14.95,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.44 1385.54) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.05,
    y: 14.89,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.44 1385.6) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.65,
    y: 14.83,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.44 1385.66) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.24,
    y: 14.77,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.44 1385.71) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.84,
    y: 14.72,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.44 1385.77) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 156.44,
    y: 14.66,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.44 1385.83) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 160.04,
    y: 14.6,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.44 1385.89) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.64,
    y: 14.54,
    width: 3.6,
    height: 90.11,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.44, 1385.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 167.24,
    y: 14.49,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.45 1386) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 170.84,
    y: 14.43,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.45 1386.06) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 174.44,
    y: 14.37,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.45 1386.12) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.04,
    y: 14.31,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.45 1386.18) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.64,
    y: 14.25,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.45 1386.23) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 185.24,
    y: 14.2,
    width: 3.6,
    height: 90.11,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.45, 1386.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 188.84,
    y: 14.14,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.45 1386.35) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 192.43,
    y: 14.08,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.46 1386.41) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 196.03,
    y: 14.02,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.46 1386.46) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.63,
    y: 13.97,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.46 1386.52) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 203.23,
    y: 13.91,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.46 1386.58) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206.83,
    y: 13.85,
    width: 3.6,
    height: 90.11,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.46, 1386.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.43,
    y: 13.79,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.46 1386.7) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 214.03,
    y: 13.73,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.46 1386.75) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 217.63,
    y: 13.68,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.47 1386.81) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 221.23,
    y: 13.62,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.47 1386.87) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 224.83,
    y: 13.56,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.47 1386.93) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 228.43,
    y: 13.5,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.47 1386.98) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 232.02,
    y: 13.45,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.47 1387.04) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 235.62,
    y: 13.39,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.47 1387.1) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 239.22,
    y: 13.33,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.47 1387.16) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 242.82,
    y: 13.27,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.48 1387.22) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 246.42,
    y: 13.22,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.48 1387.27) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 250.02,
    y: 13.16,
    width: 3.6,
    height: 90.11,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.48, 1387.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 253.62,
    y: 13.1,
    width: 3.6,
    height: 90.11,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.48, 1387.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.22,
    y: 13.04,
    width: 3.6,
    height: 90.11,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.48, 1387.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 260.82,
    y: 12.98,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.48 1387.5) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 264.42,
    y: 12.93,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.48 1387.56) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 268.02,
    y: 12.87,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.49 1387.62) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 271.62,
    y: 12.81,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.49 1387.68) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 275.21,
    y: 12.75,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.49 1387.73) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 278.81,
    y: 12.7,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.49 1387.79) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 282.41,
    y: 12.64,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.49 1387.85) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 286.01,
    y: 12.58,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.49 1387.91) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 289.61,
    y: 12.52,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.49 1387.97) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 293.21,
    y: 12.46,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.49 1388.02) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.81,
    y: 12.41,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.5 1388.08) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 300.41,
    y: 12.35,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.5 1388.14) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 304.01,
    y: 12.29,
    width: 3.6,
    height: 90.11,
    transform: "translate(1215.5 1388.2) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 307.6,
    y: 11.42,
    width: 105.07,
    height: 90.11,
    transform: "translate(1215.52 1389.07) rotate(-0.92)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1364.9 1438.54 1428.86 1383.29 1430.27 1454.87 1364.9 1438.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.23,
    y: 0.81,
    width: 28.85,
    height: 71.59,
    transform: "translate(1215.81 1385.9) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 177.08,
    y: 0.56,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.82 1386.15) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 179.4,
    y: 0.52,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.82 1386.18) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 181.72,
    y: 0.48,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.82 1386.22) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 184.05,
    y: 0.45,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.82 1386.26) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 186.37,
    y: 0.41,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.82 1386.3) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 188.69,
    y: 0.37,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.82 1386.33) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 191.02,
    y: 0.33,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.82 1386.37) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 193.34,
    y: 0.3,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.83 1386.41) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 195.67,
    y: 0.26,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.83 1386.45) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 197.99,
    y: 0.22,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.83 1386.48) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 200.31,
    y: 0.19,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.83 1386.52) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 202.64,
    y: 0.15,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.83 1386.56) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 204.96,
    y: 0.11,
    width: 2.32,
    height: 71.59,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.83, 1386.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 207.28,
    y: 0.07,
    width: 2.32,
    height: 71.59,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.83, 1386.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 209.61,
    y: 0.04,
    width: 2.32,
    height: 71.59,
    transform: "translate(1215.83 1386.67) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 211.93,
    y: 0.01,
    width: 1.39,
    height: 71.59,
    transform: "translate(1215.83 1386.7) rotate(-0.92)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 213.05,
    y: -0.01,
    width: 0.96,
    height: 71.59,
    transform: "translate(1215.83 1386.71) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 214.01,
    y: -0.03,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.83 1386.74) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 216.28,
    y: -0.07,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.83 1386.78) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 218.55,
    y: -0.11,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.84 1386.81) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 220.82,
    y: -0.14,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.84 1386.85) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 223.1,
    y: -0.18,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.84 1386.89) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 225.37,
    y: -0.22,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.84 1386.92) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 227.64,
    y: -0.25,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.84 1386.96) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.91,
    y: -0.29,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.84 1386.99) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 232.18,
    y: -0.33,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.84 1387.03) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 234.45,
    y: -0.36,
    width: 2.27,
    height: 71.59,
    transform: "translate(1215.84 1387.07) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 236.73,
    y: -0.39,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.84 1387.09) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 237.74,
    y: -0.4,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.84 1387.11) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 238.76,
    y: -0.42,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.84 1387.13) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 239.78,
    y: -0.44,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.84 1387.14) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 240.79,
    y: -0.45,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.84 1387.16) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 241.81,
    y: -0.47,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.84 1387.18) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 242.83,
    y: -0.49,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.84 1387.19) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 243.85,
    y: -0.5,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.84 1387.21) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 244.86,
    y: -0.52,
    width: 1.02,
    height: 71.59,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.85, 1387.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 245.88,
    y: -0.54,
    width: 1.02,
    height: 71.59,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.85, 1387.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 246.9,
    y: -0.55,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.26) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 247.91,
    y: -0.57,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.27) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 248.93,
    y: -0.58,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.29) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 249.95,
    y: -0.6,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.31) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 250.97,
    y: -0.62,
    width: 1.02,
    height: 71.59,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.85, 1387.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 251.98,
    y: -0.63,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.34) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 253,
    y: -0.65,
    width: 1.02,
    height: 71.59,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.85, 1387.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 254.02,
    y: -0.67,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.37) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 255.03,
    y: -0.68,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.39) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 256.05,
    y: -0.7,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.4) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 257.07,
    y: -0.71,
    width: 1.02,
    height: 71.59,
    transform: "matrix(1, -0.02, 0.02, 1, 1215.85, 1387.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 258.09,
    y: -0.73,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.44) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 259.1,
    y: -0.75,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.45) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 260.12,
    y: -0.76,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.47) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 261.14,
    y: -0.78,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.49) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 262.15,
    y: -0.8,
    width: 1.02,
    height: 71.59,
    transform: "translate(1215.85 1387.5) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 263.17,
    y: -0.86,
    width: 7.29,
    height: 71.59,
    transform: "translate(1215.85 1387.57) rotate(-0.92)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1426.4 1453.9 1430.27 1454.87 1428.86 1383.29 1426.4 1453.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1430.27 1454.87 1433.89 1453.76 1428.86 1383.29 1430.27 1454.87"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M212.47,0c-1.13,45.25-2.59,92.31-4.22,137.54l-.16,4.44.11-4.44c1.17-45.25,2.62-92.31,4.27-137.54Z",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M212.47,0c3.71,45.46,7.28,92.76,10.49,138.26l.31,4.46-.36-4.46C219.24,92.8,215.66,45.5,212.47,0Z",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1430.27 1454.87 1216.38 1401.44 1330.51 1536.71 1430.27 1454.87"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.1,
    y: 18.04,
    width: 13.13,
    height: 137.08,
    transform: "translate(1214.99 1383.42) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.22,
    y: 17.91,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215 1383.55) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.83,
    y: 17.85,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215 1383.61) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.44,
    y: 17.79,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215 1383.67) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.05,
    y: 17.74,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215 1383.73) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.66,
    y: 17.68,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215 1383.78) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.27,
    y: 17.62,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215 1383.84) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.88,
    y: 17.56,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215 1383.9) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.49,
    y: 17.51,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215 1383.96) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.1,
    y: 17.45,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.01 1384.02) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.71,
    y: 17.39,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.01 1384.07) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.32,
    y: 17.33,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.01 1384.13) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.93,
    y: 17.27,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.01 1384.19) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.54,
    y: 17.22,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.01 1384.25) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.15,
    y: 17.16,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.01 1384.3) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.76,
    y: 17.1,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.01 1384.36) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.37,
    y: 17.04,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.02 1384.42) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.98,
    y: 16.98,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.02 1384.48) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.59,
    y: 16.93,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.02 1384.54) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.2,
    y: 16.87,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.02 1384.59) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.81,
    y: 16.81,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.02 1384.65) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.42,
    y: 16.75,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.02 1384.71) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.03,
    y: 16.69,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.02 1384.77) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 93.64,
    y: 16.64,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.03 1384.83) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.25,
    y: 16.58,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.03 1384.88) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 100.86,
    y: 16.52,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.03 1384.94) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.47,
    y: 16.46,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.03 1385) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.08,
    y: 16.41,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.03 1385.06) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.69,
    y: 16.35,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.03 1385.12) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.3,
    y: 16.29,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.03 1385.17) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 118.91,
    y: 16.23,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.04 1385.23) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 122.52,
    y: 16.17,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.04 1385.29) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 126.13,
    y: 16.12,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.04 1385.35) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.74,
    y: 16.06,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.04 1385.4) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 133.35,
    y: 16,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.04 1385.46) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.96,
    y: 15.94,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.04 1385.52) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 140.57,
    y: 15.88,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.04 1385.58) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.18,
    y: 15.83,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.05 1385.64) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.79,
    y: 15.77,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.05 1385.69) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 151.4,
    y: 15.71,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.05 1385.75) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.01,
    y: 15.65,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.05 1385.81) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 158.62,
    y: 15.59,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.05 1385.87) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 162.23,
    y: 15.54,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.05 1385.93) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 165.84,
    y: 15.48,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.05 1385.98) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 169.45,
    y: 15.42,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.05 1386.04) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 173.06,
    y: 15.36,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.06 1386.1) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.67,
    y: 15.3,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.06 1386.16) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 180.28,
    y: 15.25,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.06 1386.22) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 183.89,
    y: 15.19,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.06 1386.27) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 187.5,
    y: 15.13,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.06 1386.33) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 191.11,
    y: 15.07,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.06 1386.39) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 194.72,
    y: 15.02,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.06 1386.45) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 198.33,
    y: 14.96,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.07 1386.5) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 201.93,
    y: 14.9,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.07 1386.56) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 205.54,
    y: 14.84,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.07 1386.62) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 209.15,
    y: 14.78,
    width: 3.61,
    height: 137.08,
    transform: "translate(1215.07 1386.68) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 212.76,
    y: 14.74,
    width: 1.32,
    height: 137.08,
    transform: "translate(1215.07 1386.72) rotate(-0.92)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1430.27 1454.87 1628.33 1393.87 1532.61 1533.47 1430.27 1454.87"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 214.07,
    y: 13.73,
    width: 4.44,
    height: 138.05,
    transform: "translate(1215.08 1386.76) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 218.51,
    y: 13.65,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.08 1386.85) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 224.54,
    y: 13.55,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.08 1386.94) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 230.57,
    y: 13.45,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.09 1387.04) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 236.6,
    y: 13.36,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.09 1387.14) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 242.64,
    y: 13.26,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.09 1387.23) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 248.67,
    y: 13.16,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.09 1387.33) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 254.7,
    y: 13.07,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.1 1387.43) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 260.73,
    y: 12.97,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.1 1387.53) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 266.76,
    y: 12.87,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.1 1387.62) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 272.79,
    y: 12.78,
    width: 6.03,
    height: 138.05,
    transform: "translate(1215.1 1387.72) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 278.83,
    y: 12.66,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.11 1387.83) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 286.73,
    y: 12.54,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.11 1387.96) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 294.63,
    y: 12.41,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.11 1388.08) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 302.53,
    y: 12.28,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.11 1388.21) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 310.43,
    y: 12.16,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.12 1388.34) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 318.33,
    y: 12.03,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.12 1388.46) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 326.23,
    y: 11.9,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.12 1388.59) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 334.13,
    y: 11.78,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.13 1388.72) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 342.03,
    y: 11.65,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.13 1388.84) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 349.93,
    y: 11.52,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.13 1388.97) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 357.83,
    y: 11.4,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.14 1389.1) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 365.73,
    y: 11.27,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.14 1389.22) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 373.63,
    y: 11.14,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.14 1389.35) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 381.53,
    y: 11.02,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.15 1389.48) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 389.43,
    y: 10.89,
    width: 7.9,
    height: 138.05,
    transform: "translate(1215.15 1389.6) rotate(-0.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 397.32,
    y: 10.7,
    width: 15.73,
    height: 138.05,
    transform: "translate(1215.15 1389.79) rotate(-0.92)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1430.27 1454.87 1330.51 1536.71 1431.56 1535.09 1532.61 1533.47 1430.27 1454.87"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1467.09 1534.52 1532.6 1532.93 1532.61 1533.47 1467.09 1534.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.5 1535.87 1532.57 1530.96 1532.6 1532.93 1467.09 1534.52 1330.51 1536.71 1330.5 1535.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.46 1533.9 1532.54 1528.99 1532.57 1530.96 1330.5 1535.87 1330.46 1533.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.43 1531.93 1532.51 1527.02 1532.54 1528.99 1330.46 1533.9 1330.43 1531.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.4 1529.96 1532.47 1525.05 1532.51 1527.02 1330.43 1531.93 1330.4 1529.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.37 1527.99 1532.44 1523.08 1532.47 1525.05 1330.4 1529.96 1330.37 1527.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.34 1526.02 1532.41 1521.12 1532.44 1523.08 1330.37 1527.99 1330.34 1526.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.31 1524.05 1532.37 1519.15 1532.39 1519.95 1532.41 1521.12 1330.34 1526.02 1330.31 1524.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.27 1522.08 1532.33 1517.18 1532.37 1519.15 1330.31 1524.05 1330.27 1522.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.24 1520.11 1532.28 1515.21 1532.33 1517.18 1330.27 1522.08 1330.24 1520.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.21 1518.14 1532.23 1513.24 1532.28 1515.21 1330.24 1520.11 1330.21 1518.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.18 1516.18 1532.18 1511.27 1532.23 1513.24 1330.21 1518.14 1330.18 1516.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.15 1514.21 1532.13 1509.3 1532.18 1511.27 1330.18 1516.18 1330.15 1514.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.12 1512.24 1532.09 1507.33 1532.13 1509.3 1330.15 1514.21 1330.12 1512.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.09 1510.27 1532.04 1505.37 1532.09 1507.33 1330.12 1512.24 1330.09 1510.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.05 1508.3 1531.99 1503.4 1532.04 1505.37 1330.09 1510.27 1330.05 1508.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1330.02 1506.33 1531.94 1501.43 1531.99 1503.4 1330.05 1508.3 1330.02 1506.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1329.99 1504.36 1531.9 1499.46 1531.94 1501.43 1330.02 1506.33 1329.99 1504.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1329.96 1502.39 1531.85 1497.49 1531.9 1499.46 1329.99 1504.36 1329.96 1502.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1329.93 1500.42 1531.8 1495.52 1531.85 1497.49 1329.96 1502.39 1329.93 1500.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1329.89 1498.45 1531.75 1493.55 1531.8 1495.52 1329.93 1500.42 1329.89 1498.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1329.86 1496.48 1531.7 1491.59 1531.75 1493.55 1329.89 1498.45 1329.86 1496.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1329.83 1494.52 1531.66 1489.62 1531.7 1491.59 1329.86 1496.48 1329.83 1494.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1329.8 1492.55 1531.61 1487.65 1531.66 1489.62 1329.83 1494.52 1329.8 1492.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1530.77 1453.26 1531.61 1487.65 1329.8 1492.55 1329.22 1456.49 1530.77 1453.26"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1364.9 1438.54 1428.86 1383.29 1426.4 1453.9 1364.9 1438.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1487.15 1437.35 1429.13 1383.28 1433.83 1453.9 1487.15 1437.35"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M-1216.38,356.75c1.51,6.3,396.55-31.84,443.24-35.92,157.24-13.74,301.56-50.32,448.05-92.44,118.72-34.13,216.94-87,271.82-186C5.24-63.25-9.23-190-58.08-303.94c-61.25-142.88-183.31-273.13-201.09-421.44-14.44-120.49,43.37-230.07,110.82-326.73,34.27-49.1,106-134.5,8.82-176.14-31.89-13.66-82.71-30.61-123.83-42.5-42.65-12.33-84.66-26.71-126.3-41.84-60.19-21.88-121-52.14-183.25-68.16-4-1-8.27-2.56-12.44-2.53,93.34,17.31,255.15,30.59,420.6,56,134.75,20.68,406.1,68.64,434.8,185,16.15,65.51-72.32,153.65-93,215.71-28.89,86.53-26.89,182.75,7.05,272.8,43.7,115.92,135.37,216.4,217.15,318.66C859,237.32,150.91,691.47-375.39,874.47c-47.53,16.53-674,177.4-684.68,133.1Z",
    transform: "translate(1216.38 1383.28)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174,175.63c17.1,6.07,37.83-3.51,53.07-10.6,21.95-10.23,44.58-9.23,68.21-8.25a77.76,77.76,0,0,0,22.07-2.2c-12.21,2.34-24.63-1.42-36.95-3.05a108.34,108.34,0,0,0-45.35,3.67c-12.38,3.73-24,9.65-36.17,14-8.7,3.09-14.46,2.71-22.87-.17-1.91-.65-3.84-1.31-5.8-1.88-1-.29-2-.54-3-.76s-2-.49-3-.65c-7.88-1.52-15.47-1.72-22.53-2.17s-13.6-1-19.35-2.44l-2.12-.56-2-.67a17.13,17.13,0,0,1-3.57-1.58,9,9,0,0,1-2.6-2.16,3.59,3.59,0,0,1-.65-1.16l0-.13a2.76,2.76,0,0,1,0-.39c0-.3,0-.56,0-.89.09-.7.18-1.39.27-2l-.3-.12-.42,0-.84-.07-1.67-.16-2.32-.22c-1.29-.13-2.56-.28-3.81-.44-2.49-.33-4.9-.71-7.21-1.14s-4.55-.91-6.69-1.42l-1.58-.39c-.5-.13-1-.27-1.47-.43A15.71,15.71,0,0,1,82.74,146a8,8,0,0,1-2.09-1.59,2.65,2.65,0,0,1-.79-1.93c0-1.33,1.6-2.72,3.15-3.76a114.51,114.51,0,0,1,12.28-7c-4.77.7-9,2.82-13.07,5.24a15.18,15.18,0,0,0-2.69,2,7,7,0,0,0-1.25,1.58,5.13,5.13,0,0,0-.46,1,4.64,4.64,0,0,0-.26,1.1,4.58,4.58,0,0,0,0,1.11,5.49,5.49,0,0,0,.22,1,6.06,6.06,0,0,0,.89,1.63,9.93,9.93,0,0,0,2.51,2.22,17.58,17.58,0,0,0,3,1.52c.52.21,1.05.4,1.6.58l1.58.49c2.15.66,4.39,1.27,6.73,1.85s4.78,1.09,7.31,1.55c1.26.23,2.55.45,3.87.64l1,.15.45.06.16,0,.33.06.16,0h.08l0,.1a1.64,1.64,0,0,0-.05.37,2.35,2.35,0,0,0,0,.26,1.05,1.05,0,0,0,0,.18l.09.37a7.72,7.72,0,0,0,1.17,2.54,12.79,12.79,0,0,0,3.51,3.35,20.51,20.51,0,0,0,4.17,2.13l2.18.84,2.27.72c6.14,1.87,13,2.7,20.16,3.33s14.64,1,22,2.61c.93.16,1.84.42,2.75.64s1.83.47,2.75.76C170.24,174.3,172.1,175,174,175.63Z",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M331,130.76c5.71,1.57,15.35,7.55,10.83,14.82-3.43,5.52-15,12.46-21.83,9.19a1.28,1.28,0,0,1-.25-2c1.79-1.63,4.06-1.69,6.34-2.33a33.26,33.26,0,0,0,8-3.25c2.64-1.55,6.1-3.57,5.49-7.7-.45-3-6.68-6.58-8.73-8.1-.3-.22-.23-.73.15-.62",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.69,135.42l0-.08c0,.16,0,.32,0,.49a1.2,1.2,0,0,1-.15-.82,1.48,1.48,0,0,1,.54-.9,4.59,4.59,0,0,1,.57-.32.69.69,0,0,1,1.06.73,3.68,3.68,0,0,1-.17.8,1.36,1.36,0,0,1-.63.72,1.15,1.15,0,0,1-.92.08l.45-.07-.06,0a.48.48,0,0,1-.6,0,.59.59,0,0,1-.1-.63",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.53,136.78l-.14-.21a1.7,1.7,0,0,1,.3-2.11l.21-.22a1.64,1.64,0,0,1,1.83-.38,1.55,1.55,0,0,1,.77,1.65,2.31,2.31,0,0,1-1,1.55,1.46,1.46,0,0,1-1.94-.28",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.36,139l-.07.05a1.73,1.73,0,0,1-2,0,1.92,1.92,0,0,1-.68-1.86,2.65,2.65,0,0,1,1.23-1.84,1.71,1.71,0,0,1,2,0l.06.05a1.61,1.61,0,0,1,.56.74,2.18,2.18,0,0,1,.11,1.05,2.76,2.76,0,0,1-.41,1.06,2.68,2.68,0,0,1-.79.75",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M82.18,138.64c.1-.2.22-.4.3-.6a4.83,4.83,0,0,1,.25-.76,5.17,5.17,0,0,1,1.1-1.14.65.65,0,0,1,1.06.75,7.17,7.17,0,0,1-.74,1.4,2.3,2.3,0,0,1-.6.45,4.2,4.2,0,0,0-.55.49.51.51,0,0,1-.82-.59",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93,133.06s0,0-.09,0l.53-.23c.25-.29-.15.17-.25.24a1.74,1.74,0,0,1-.47.24l-.26.07-.41.11a1.3,1.3,0,0,1-.48,0c-.1,0-.43,0-.16,0a1.47,1.47,0,0,0-.21,0c.28,0-.14.09.08,0-1,.48-1.9-.52-1.21-1.58a3,3,0,0,1,2.16-1.38,1.5,1.5,0,0,1,1.44,2c0-.2,0-.4,0-.6a2.24,2.24,0,0,1,.09.45.67.67,0,0,1-.77.73",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.16,136.88l-.07.06a1.77,1.77,0,0,1-2,0,1.91,1.91,0,0,1-.69-1.86,2.63,2.63,0,0,1,1.24-1.85,1.73,1.73,0,0,1,2,0l0,.05a1.56,1.56,0,0,1,.57.74,2.09,2.09,0,0,1,.1,1.06,2.43,2.43,0,0,1-.41,1,2.26,2.26,0,0,1-.79.75",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.59,136l0,0a1.52,1.52,0,0,1,.33.78,1.8,1.8,0,0,1,.06.93l-.18.64a3.08,3.08,0,0,1-.71,1.07l0,0-.5.38-.57.25a1.61,1.61,0,0,1-.89.05,1,1,0,0,1-.54-.17.93.93,0,0,1-.44-.32,1,1,0,0,1-.33-.44,1.14,1.14,0,0,1-.2-.55,1.85,1.85,0,0,1,0-.94l.18-.66.31-.58.42-.5.51-.38.56-.25a1.6,1.6,0,0,1,.89,0,.93.93,0,0,1,.53.17,1.29,1.29,0,0,1,.63.5",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.84,169.45l.06-.06c-.13.46-.26.92-.4,1.38a.57.57,0,0,0,0-.13,1.43,1.43,0,0,1,.88-1.59,2,2,0,0,1,.43-.08l-.33.06a1.4,1.4,0,0,1,1.8.79,2,2,0,0,1-.54,2.32,1.61,1.61,0,0,1-1,.39,1.38,1.38,0,0,1-1.08-.53,1.85,1.85,0,0,1-.38-1.27,2.12,2.12,0,0,1,.54-1.28",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.85,171.45l-1.9.05c-.73,0-.64-1.32.09-1.31l1.89.05c.67,0,.6,1.2-.08,1.21",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.93,171.84l-.05,0a1.48,1.48,0,0,1-.8.25,1,1,0,0,1-.59-.16.94.94,0,0,1-.47-.37,1.66,1.66,0,0,1-.34-.79v-.05a2.1,2.1,0,0,1,.07-.93,1.58,1.58,0,0,1,.32-.6,1.41,1.41,0,0,1,.46-.45,1.52,1.52,0,0,1,.79-.24h0a1.32,1.32,0,0,1,.77.24,1.55,1.55,0,0,1,.51.64,2.1,2.1,0,0,1-.13,1.81,1.9,1.9,0,0,1-.56.6",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.08,170.2a5.86,5.86,0,0,0,1.54-.9,4.26,4.26,0,0,1,1.53-.9,4,4,0,0,1,3.48.65,1.58,1.58,0,0,1-.16,2.49,6.28,6.28,0,0,1-2.94.57c-1.19-.05-2-.85-3.24-.66-.73.12-.91-.93-.21-1.25",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157.56,168.21a2.64,2.64,0,0,1,3.16,0,3.51,3.51,0,0,1-.31,5.51,2.82,2.82,0,0,1-3.18,0A3.07,3.07,0,0,1,156,171a3.65,3.65,0,0,1,1.54-2.75",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.09,170.72a2.44,2.44,0,0,1,1.38.4l-.54-.27a3.38,3.38,0,0,0,.44.18,2.4,2.4,0,0,1,1,3.43,3.13,3.13,0,0,1-2.61,1.76,2.47,2.47,0,0,1-2.24-2.76,2.82,2.82,0,0,1,2.53-2.74",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.67,170.38a6.94,6.94,0,0,1,.93.14c1.33.29,1.77,2.61.67,3.64a9.19,9.19,0,0,1-.76.64,1.93,1.93,0,0,1-3-1.42c-.26-1.39.78-3.14,2.12-3",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.29,174.16a2.57,2.57,0,0,1,2.6.6,3.58,3.58,0,0,1,.94,1.13c.06.1.11.2.16.3a2.42,2.42,0,0,1-.38,2.52c-.84,1.11-2.35,2-3.57,1.44A2.9,2.9,0,0,1,170.7,179a3.11,3.11,0,0,1-.49-1.88,3.33,3.33,0,0,1,2.08-3",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184,174c.2.18.42.37.61.57a3,3,0,0,1,.66,2,3.17,3.17,0,0,1-.78,2c-.2.2-.43.39-.65.57a2.36,2.36,0,0,1-1.32.41,2.28,2.28,0,0,1-1.3-.41,3.07,3.07,0,0,1-1.2-2.6,3.28,3.28,0,0,1,1.37-2.59,2.35,2.35,0,0,1,1.32-.4,2.26,2.26,0,0,1,1.29.4",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.43,176.13c1.1-.93,2.71-.45,3.7.67a1.69,1.69,0,0,1,.28,2,2.47,2.47,0,1,1-4-2.72",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.46,177.84a4.32,4.32,0,0,1-.34-.68,2.51,2.51,0,0,1,1.14-3.25,2.27,2.27,0,0,1,1.48-.08,2.43,2.43,0,0,1,1.51,1.26,2.53,2.53,0,0,1,.2,2.06c-.13.3-.25.59-.4.87l-.41.45a1.41,1.41,0,0,1-.81.37,2,2,0,0,1-1.45-.19.09.09,0,0,0-.06,0l.52.19a2.24,2.24,0,0,1-1.38-1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M203.19,173.07a1.8,1.8,0,0,1,1.08-1.4,8.56,8.56,0,0,1,1.14-.25c.92-.18,1.91,1.25,1.47,2.16a10.2,10.2,0,0,1-.54,1.1,1.61,1.61,0,0,1-1.57.72,1.79,1.79,0,0,1-1.58-2.33",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.74,173.28a2,2,0,0,1-1.31-.51l-.34-.38a1.8,1.8,0,0,1-.33-.75,1.94,1.94,0,0,1,0-1.26,1.67,1.67,0,0,1,1-1.06,1.8,1.8,0,0,1,.95-.08,1.82,1.82,0,0,1,.94.49,1.74,1.74,0,0,1,.51.94,1.47,1.47,0,0,1-.2,1l0,.05.15-.3,0,.1c0-.12.05-.25.08-.37a.19.19,0,0,0,0,.08c0-.15,0-.29,0-.43a.51.51,0,0,0,0,.13c0-.16-.09-.31-.13-.47a.61.61,0,0,0,.05.12l-.26-.47a2.79,2.79,0,0,1,.34.76,2.84,2.84,0,0,1,.1.82c0,.16-.07.32-.1.48a1.42,1.42,0,0,1-.37.6,1.54,1.54,0,0,1-1,.52h0l.44-.1,0,0,.35-.21s0,0,0,0l.25-.29a1.3,1.3,0,0,1-1,.58",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.5,168a2.51,2.51,0,0,1,1.71-1.53,1.74,1.74,0,0,1,1.49.05,1.86,1.86,0,0,1,.72.59,2.29,2.29,0,0,1,.06,2.43,5.8,5.8,0,0,1-.36.59,2.23,2.23,0,0,1-1.52.87c-1.36.23-2.61-1.7-2.1-3",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.42,166.23a3.53,3.53,0,0,1-4-2.13,3.35,3.35,0,0,1,1.85-4.65,4.08,4.08,0,0,1,5.11,2.11,3.62,3.62,0,0,1-2.08,5c-1.35.41-2.73-1.67-1.49-2.62a1.4,1.4,0,0,0,.45-.54c0-.15,0-.4,0-.52s-.09,0,0,.1l.26.2c-.18-.08-.21-.1-.11-.06s.07,0-.13,0c.23,0-.12,0-.2,0s-.12,0,0,0l-.28.08a2.57,2.57,0,0,0-.71.31l-.4.34s.05-.15,0,0,0,0,0,0a1.44,1.44,0,0,0,.22.27,1.55,1.55,0,0,0,1,.36c.88,0,1.47,1.57.52,1.8",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.41,163.64l.09.1-.39-.41.19.17-.36-.25.15.09c.19.12-.31-.08-.13-.05a2.93,2.93,0,0,1,1.66,2.47,2.57,2.57,0,0,1-.42,1.85c-.35.37-.9.35-1.48-.16a5,5,0,0,1-1.39-2.63c-.17-.89,0-1.59.35-1.88s1.1,0,1.73.7",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.93,159.8a3,3,0,0,1,1.56-1.22,2.59,2.59,0,0,1,2.39.54,1.6,1.6,0,0,1,.18,2.34c.14-.17.17-.2.09-.08s-.06.1.07-.16a1.35,1.35,0,0,1-.32.68c-.1.17-.07.11.08-.2l-.06.19c.06-.39.07-.48.05-.27a.67.67,0,0,0,0,.2,1.94,1.94,0,0,1-2.89,1.68,2.72,2.72,0,0,1-1.15-3.7",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.5,158.74c-.09-.27-.21-.61-.27-.88a3.24,3.24,0,0,1,.53-2.48,2.61,2.61,0,0,1,1.91-1.14,3.72,3.72,0,0,1,1.58.34,3.41,3.41,0,0,1,1.86,2.48,3.65,3.65,0,0,1-.06,1.71,6.69,6.69,0,0,1-.44.89c.11-.22.21-.45.32-.68a3.41,3.41,0,0,1-.59,1,2.83,2.83,0,0,1-.93.68,2.71,2.71,0,0,1-2.22-.15,3.6,3.6,0,0,1-1.69-1.79",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247,155.11a2.56,2.56,0,0,1,1.8-.76,2.63,2.63,0,0,1,1.23.24,1.58,1.58,0,0,1,.53,2.18,3,3,0,0,1-.84,1,2.29,2.29,0,0,1-1.51.58,1.6,1.6,0,0,1-1.66-1.08,2,2,0,0,1,.45-2.15",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.39,157.75a2.85,2.85,0,0,1,.37-2,2.12,2.12,0,0,1,2.15-1,2.54,2.54,0,0,1,2,1.33,1.9,1.9,0,0,1-.51,2.64c.38-.26.16-.11.07,0a2.32,2.32,0,0,1-.54.44c-.3.17.26-.29.12-.1a2,2,0,0,1-.43.35,2,2,0,0,1-2.44-.14,2.58,2.58,0,0,1-.81-1.45",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.5,157.41a2.8,2.8,0,0,1,.1-1.44,2.32,2.32,0,0,1,.75-1,1.62,1.62,0,0,1,1.16-.31,2.29,2.29,0,0,1,2.05,1.93,1.92,1.92,0,0,1-.15,1,1.62,1.62,0,0,1-.62.7s.36-.27.23-.16a1.45,1.45,0,0,1-.4.26l-.22.12c.13-.08.25-.17.37-.26l-.16.16.31-.39-.06.09a1.7,1.7,0,0,1-1.68.85,4.61,4.61,0,0,1-.63-.2l.45.14-.14,0h.37a1.44,1.44,0,0,1-1.13-.34,2.08,2.08,0,0,1-.6-1.13",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.62,156.49a3.4,3.4,0,0,0,.83-.82A1.78,1.78,0,0,1,271,155a1.16,1.16,0,0,1,1.1,0,1.31,1.31,0,0,1,.59,1.51,1.25,1.25,0,0,1-1.53,1,3.12,3.12,0,0,0-1.14,0,.65.65,0,0,1-.44-1.1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.3,166.13a2.51,2.51,0,0,1-1-.68,3.06,3.06,0,0,1-.49-1,3.81,3.81,0,0,1-.31-1.35c0-1,.08.52,0,0,0-.11.18.5,0,.11a2.05,2.05,0,0,1,.79-2.38,3.24,3.24,0,0,1,1.49-.49,2.19,2.19,0,0,1,1.93,1.06,3.33,3.33,0,0,1,.26,3.25,2.89,2.89,0,0,1-1.09,1.25,1.84,1.84,0,0,1-1.56.25",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.55,158.19a3.2,3.2,0,0,1-.36-.9c0-.31,0-.63-.08-.94-.07-.7.79-1.09,1.06-.48.13.26.27.53.38.8a4.09,4.09,0,0,1,.14,1c.07.76-.84,1.17-1.14.52",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.11,154.94a2.89,2.89,0,0,1-1.43.36,2.62,2.62,0,0,1-1.12-.35s-.46-.32-.21-.16-.4-.2-.33-.17a2,2,0,0,1-.45-.3l-.27-.21s-.34-.16-.15-.08a1.83,1.83,0,0,1,0-3.18,4,4,0,0,1,2.71-.85c1.15.18,2.46.74,2.5,2.27a2.88,2.88,0,0,1-1.25,2.67",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102,153.55a1.77,1.77,0,0,0-.84.16,1.6,1.6,0,0,1-1.18-.18,4.06,4.06,0,0,1-1.35-1.13,1.07,1.07,0,0,1,.56-1.56,4.49,4.49,0,0,1,2,0,1.53,1.53,0,0,1,.89.65,1.48,1.48,0,0,0,.61.65c.7.4,0,1.51-.69,1.39",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.93,150.38A3.88,3.88,0,0,1,96.24,148a3.81,3.81,0,0,1,2.41-1.07,3.88,3.88,0,0,1,2.48.87,1.88,1.88,0,0,1-.75,3.07c.18-.07-.4.38-.07,0a2.12,2.12,0,0,0-.26.26l.2-.25c-.11.14-.21.28-.33.41a3.53,3.53,0,0,1-.64.64c-.33.25-.37.29-.15.12s.18-.14.07,0a2.7,2.7,0,0,1-1.54,1,2.21,2.21,0,0,1-2.73-2.64",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M87.23,142.83a1.61,1.61,0,0,1-.92-.24,1.49,1.49,0,0,1-.7-.57,1.68,1.68,0,0,1-.38-.88,2,2,0,0,1-.06-1c.06-.24.13-.48.19-.72a3.4,3.4,0,0,1,.81-1.2,2.81,2.81,0,0,1,1.84-.8,1.57,1.57,0,0,1,.91.24,1.46,1.46,0,0,1,.7.56A1.74,1.74,0,0,1,90,139a2.3,2.3,0,0,1,.06,1.05c-.06.24-.13.48-.19.73a3.37,3.37,0,0,1-.8,1.2,2.8,2.8,0,0,1-1.85.81",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.45,142.54a1.86,1.86,0,0,1-.1.31l.05-.32,0,.19a1.55,1.55,0,0,1-1,1.58,1.35,1.35,0,0,1-1.47-.56,1.05,1.05,0,0,1,0-1.1,1.12,1.12,0,0,1,.91-.61c-.15,0-.18,0-.08,0l-.1,0a.54.54,0,0,1,.16-.1,1.42,1.42,0,0,1,.67-.19,1,1,0,0,1,.84.48h-.77s.06,0,0,0a.57.57,0,0,1,.61-.26.47.47,0,0,1,.29.55",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M88.94,135.13l-.19,0-.47.07-.46-.07-.39-.2a1.08,1.08,0,0,1-.42-.5.78.78,0,0,1-.16-.43.86.86,0,0,1,0-.48,1.15,1.15,0,0,1,.07-.52,1.67,1.67,0,0,1,.32-.72l.09-.18a2.55,2.55,0,0,1,.77-.73,1.9,1.9,0,0,1,1-.27,1.5,1.5,0,0,1,.88.27,1.22,1.22,0,0,1,.45.53,1.38,1.38,0,0,1,.23.69,2.38,2.38,0,0,1-.15,1.08,2.61,2.61,0,0,1-.61.9,2.1,2.1,0,0,1-.88.52",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M82,137.85a2.47,2.47,0,0,1,.64-.34.62.62,0,0,1,.77.75.86.86,0,0,1-1,.75,2,2,0,0,1-.55-.34.52.52,0,0,1,.13-.82",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.21,134.32a1,1,0,0,1-.78-.38,1.23,1.23,0,0,1-.22-.93,1.61,1.61,0,0,1,.48-.93,1.37,1.37,0,0,1,.89-.38,1,1,0,0,1,.79.38,1.27,1.27,0,0,1,.21.93,1.66,1.66,0,0,1-.47.93,1.4,1.4,0,0,1-.9.38",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.43,135.58c-1.2,0-.91-2.06.29-2.06s.91,2.06-.29,2.06",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89,136.42c-.07.12-.08.11,0,0s0-.13,0,0a2.12,2.12,0,0,1-.1.36,1.82,1.82,0,0,1-.77.83,3.46,3.46,0,0,1-.52.32,1.11,1.11,0,0,1-.8,0,.7.7,0,0,1-.42-.79,1.78,1.78,0,0,1,.23-.74,2.81,2.81,0,0,1,.55-.54,1.66,1.66,0,0,1,.83-.47,1,1,0,0,1,.46,0c.17.06-.31.05,0,0,.58-.19,1,.53.59,1.07",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83.78,140.68l-.44-.26c-.35-.21-.24-.91.17-1.12L84,139a.83.83,0,0,1,.87,0,.87.87,0,0,1,.3.83,1.2,1.2,0,0,1-.54.82.8.8,0,0,1-.87,0",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M82.6,142.7a2.1,2.1,0,0,1,.81.54c.18.23-.19-.13-.07-.05l.17.11a1.48,1.48,0,0,1,.33,2,1.76,1.76,0,0,1-2,.78,1.57,1.57,0,0,1-1.21-1.53,1.91,1.91,0,0,1,.58-1.5,1.36,1.36,0,0,1,1.39-.39",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.88,147.28c.49.11,1,0,1.51.1.67.13,1,.75,1.39,1.29a1.34,1.34,0,0,1-1.32,2c-.62-.17-1.3-.26-1.65-.88-.26-.45-.38-1-.66-1.41a.74.74,0,0,1,.73-1.1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.45,150.18c1,0,2-.44,3-.53a5.71,5.71,0,0,1,2.82.47,1.18,1.18,0,0,1,0,2,4.35,4.35,0,0,1-3.43.78,8.32,8.32,0,0,1-2.76-1.76.6.6,0,0,1,.38-1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M102.21,151.65a5.76,5.76,0,0,1,2.25-.63,4.08,4.08,0,0,1,2.07,1,1.19,1.19,0,0,1-.46,2,4.58,4.58,0,0,1-2.4.31c-.8-.19-1.19-.78-1.79-1.27a.84.84,0,0,1,.33-1.38",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M111.39,153.52c.25.21.25.29,0,.25a.63.63,0,0,1,.39.1,2.83,2.83,0,0,1,.65.6,5.67,5.67,0,0,1,.75,2.22c.12.67-.21.3.6.3a2.2,2.2,0,0,1,1.18.43,3.76,3.76,0,0,1,1.15,2.5,1.61,1.61,0,0,1-1.39,1.79,2.52,2.52,0,0,1-2.93-2.71c0-.24.11-.48.17-.72-.14.17-.23.14-.27-.1a5.55,5.55,0,0,1-1.39-1.81c-.3-.88.07-1.57.16-2.44.05-.49.66-.79.93-.41",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M119.54,160.59c2.15.52,4.24-.76,6.44,0a21,21,0,0,1,5.07,2.72,1.52,1.52,0,0,1-.52,2.51,12.76,12.76,0,0,1-6.44.36c-2.55-.61-3.18-2.9-5.18-4.28-.61-.42,0-1.49.63-1.33",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M140.6,169.59c-.52,0-.45-.92.07-.92s.45.92-.07.92",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.43,168.62a1.25,1.25,0,0,1-1.57,0,1.33,1.33,0,0,1-.44-1.43c.14-.32.48-.64.79-.49a2.26,2.26,0,0,1,.22.11s.21.17.08.08c.06,0,.15,0,0,0s.19.07.07,0h.07a.34.34,0,0,1,.17.05.72.72,0,0,1,.27.15c0,.05-.1,0,0,0s.2,0,.07,0a.75.75,0,0,1,.21,1.38",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M159.14,176.67a4.64,4.64,0,0,1,.25-1.23,2.79,2.79,0,0,1,3.2-1.88c.84.12,1.25.79,1.07,1.78a4.3,4.3,0,0,1-1,2.18,2.82,2.82,0,0,1-1.31.73,2.63,2.63,0,0,1-1.31-.08,1.42,1.42,0,0,1-.9-1.5",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.16,169c1.41-1.11,2.43-2.19,4.23-2.13a6.65,6.65,0,0,1,4.48,2.39,2.6,2.6,0,0,1-.6,3.65,6.67,6.67,0,0,1-5.35.74c-1.67-.61-2.19-2-3.1-3.51a1,1,0,0,1,.34-1.14",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M170.17,171.93a12.3,12.3,0,0,1,3.43.17c1.08.27.77,2.45-.37,2.3a6.14,6.14,0,0,1-1.69-.41l-1.59-.68a.73.73,0,0,1,.22-1.38",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M178.47,175.28a2.19,2.19,0,0,0,1.09.23c.44,0,.83.07,1.26.09a1,1,0,0,1,.37,1.85,2.15,2.15,0,0,1-2,.27,3.75,3.75,0,0,1-1.47-1.11c-.42-.52.06-1.65.72-1.33",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M187.25,177.9l2.54.53c.51.11.28,1-.23.92l-2.53-.63c-.46-.12-.24-.92.22-.82",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M196.32,175.43a8.43,8.43,0,0,1,2.49-1,.56.56,0,0,1,.36.94,8.69,8.69,0,0,1-2.48,1c-.54.19-.9-.74-.37-1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.05,177.35c-.6.11-1.21.3-1.81.35-.83.07-1.47-.57-2.13-1.06-.91-.7-.54-2.6.68-2.54a3.55,3.55,0,0,1,2.27.46,15,15,0,0,1,1.31,1.53c.31.37.17,1.16-.32,1.26",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M170.22,172.65c-.81-.08-1.65-.09-2.44-.24a9.52,9.52,0,0,1-2.3-1c-.8-.39-.74-2.16.34-2a11.36,11.36,0,0,1,2.53.44,24.53,24.53,0,0,1,2.31,1.24c.63.34.26,1.63-.44,1.56",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M160,170.18a9.36,9.36,0,0,0-3.64-.57c-.45,0-.51-.8-.06-.91a5.58,5.58,0,0,1,4,.5c.5.25.25,1.21-.29,1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M149.78,170.05a1,1,0,0,0-.65-.12c-.29.1-.76.62-1.25.71a3,3,0,0,1-2.29-.29,1.33,1.33,0,0,1-.53-1.24,2.47,2.47,0,0,1,1.13-1.93,3,3,0,0,1,2-.59,2.73,2.73,0,0,1,1.46,1,11.28,11.28,0,0,1,1,1c.49.61-.12,1.73-.84,1.47",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.58,170.79a4,4,0,0,1-1.32.86,2.55,2.55,0,0,1-2-.21,2.66,2.66,0,0,1-.77-.62s-.6-1-.47-1.12.08.3.11.38a2.68,2.68,0,0,1-.14-.94,2.93,2.93,0,0,1,2.08-2.66c1.57-.43,2.71.48,3.15,2.09a2.56,2.56,0,0,1-.67,2.22",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.39,170.2c0,.07-.25-.28-.13-.17l.78.12a1.38,1.38,0,0,1-1.11,0l-.19-.09a1.55,1.55,0,0,1-.51-.42c-.1-.11-.18-.24-.29-.35.18.19-.09-.07-.12-.11a1.13,1.13,0,0,1-.24-.29,1.41,1.41,0,0,1,.66-2.08,2.13,2.13,0,0,1,1.61.08,1.88,1.88,0,0,1,1,2.46l0-.9a4.52,4.52,0,0,1,.22,1.28,1.07,1.07,0,0,1-.7.94.76.76,0,0,1-.92-.44",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.73,144.49a1.83,1.83,0,0,1,.39.6,1.59,1.59,0,0,1,.11.65,3,3,0,0,1-.15.78l.1-.72c0,.09,0,.17,0,.26a1.35,1.35,0,0,1-1.2,1.45h-.23l.63-.19a1.63,1.63,0,0,1-1.31.21,2.81,2.81,0,0,1-.6-.36,1.77,1.77,0,0,1,0-2.51,1.45,1.45,0,0,1,2.29-.18",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.72,146.39c1.93,0,3.06.79,4.69,1.62a6.15,6.15,0,0,0,3.75.45,3.63,3.63,0,0,1,2.36.57c.75.43.45,1.74-.29,2.22a3.33,3.33,0,0,1-3.18.43,25.23,25.23,0,0,0-3.89-.88c-2.12-.39-3.56-1.37-4-3.68a.67.67,0,0,1,.6-.73",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101.37,151c.71-2.73,4.63-2.5,6.14-1.71,1.94,1,4,2.91,3.87,5.58a2.27,2.27,0,0,1-2.65,2.08c-1-.2-1.51-.94-2.33-1.42s-1.66-.58-2.4-1c-1-.61-3.06-1.83-2.63-3.51",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M114.24,155.46a4,4,0,0,1,1.28,1.62,8.31,8.31,0,0,1,.34,2.33c0,.23,0,.18,0-.15,0,.09.07.19.11.28.14.25.26.53.4.78.28.52.62,1,.93,1.5a1,1,0,0,1-.74,1.56c-1.61.08-2.66-.81-3.91-1.61a3.53,3.53,0,0,1-1.57-1.93,4.29,4.29,0,0,1,.51-3.61c.49-1,2-1.42,2.67-.77",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.47,163.39a3.68,3.68,0,0,1,2-.36,5.48,5.48,0,0,1,1.72,1.06,1.1,1.1,0,0,1-.63,1.88,5,5,0,0,1-2.08-.05c-.61-.2-1-.88-1.42-1.38a.78.78,0,0,1,.38-1.15",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M130.84,165.73l3.73.52c.74.1.51,1.3-.24,1.18l-3.71-.61c-.53-.09-.31-1.16.22-1.09",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M163.91,171.79a47.26,47.26,0,0,1,5.68,1c.35.1.25.76-.12.73a49.16,49.16,0,0,1-5.77-1.05c-.41-.08-.19-.78.21-.71",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111,141.73c1.36,1.68,3.76,2.63,5.8,3.12.37.08.28.74-.1.84a6,6,0,0,1-7.07-2.61c-.61-.92.67-2.22,1.37-1.35",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.33,147.4c2.7.14,5.32.3,8,.31,2.41,0,4.19,1.46,6.46,2,3.07.7,6.18-.13,9.07,1.34s6,2.91,8.81,4.62c.46.28.07,1.17-.43,1-3.5-1.26-5.57-2-9.46-1.42-2.81.4-7.11.52-9.7-.46-2-.77-3.83-2.72-5.54-4.1-2.28-1.84-4.42-2.29-7.31-2.9-.17,0-.1-.36.08-.35",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.15,155.19c.11.36.87.46,1.15.41a.53.53,0,0,1,.31,1,1.67,1.67,0,0,1-2.55-1.06.57.57,0,1,1,1.09-.33",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.08,158.48c1.58-2.89,4.27-2.64,7-3.21q6.3-1.29,12.61-2.47c4.22-.78,8.45-1.54,12.69-2.25,3.29-.56,6.61-1.51,10-.68a1.46,1.46,0,0,1,.47,2.48c-3.21,2-7.37,2.07-11,2.67q-5.94,1-11.85,2t-11.79,2.21c-2.89.56-5.45,2-7.94-.09a.56.56,0,0,1-.18-.68",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.68,150.21c.88-.78,1.36-1.77,2.42-2.32a11.33,11.33,0,0,1,3.8-.82,14.36,14.36,0,0,1,7.57.69c1,.41,1.28,2,.21,2.37a33.33,33.33,0,0,1-7,1.34,16.49,16.49,0,0,1-3.83.5c-1.08-.09-2-.73-3-.93-.38-.07-.39-.62-.16-.83",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.3,147.13a11.78,11.78,0,0,1,7.68-3.86,38.61,38.61,0,0,0,6.24-1.09c1.75-.51,2.5-.81,4.33-.1a1.67,1.67,0,0,1,.9,2.47c-2.17,2.58-6,2.2-9,3.4a12.73,12.73,0,0,1-9.69.46c-.47-.17-.81-.87-.43-1.28",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.3,141.28a8.1,8.1,0,0,1,1.93-1.6,8.88,8.88,0,0,1,3-.15c2-.08,3.83-.47,5.83.12a.76.76,0,0,1,0,1.46c-2,.44-4.07.19-6,.84a9.38,9.38,0,0,1-2.07.76,13,13,0,0,1-2.38-.35c-.49-.05-.55-.81-.24-1.08",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.14,138.68c1.81-.2,3.72-.45,5.51-.76s2.9-.79,4.57,0a1.22,1.22,0,0,1-.07,2.05c-1.54.85-2.74.38-4.32.18-1.83-.22-3.79-.36-5.62-.47-.54,0-.65-.95-.07-1",
    transform: "translate(1216.38 1383.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268,144.23c1.86-1.69,3.41-2.6,5.79-2.61,1.69,0,3.26.36,5,.22a34.1,34.1,0,0,1,3.88-.43,68.84,68.84,0,0,1,18.51,3.46c3.94,1.38,6.72,2.56,10.83,1.56a21.62,21.62,0,0,0,7.34-3.28,20.77,20.77,0,0,0,4.81-5.12c1-1.34,1.67-1.94,3.2-2.1,2.39-.25,4.23,3.15,3.71,5.61a13,13,0,0,1-9.49,9.67c-5.67,1.53-11-.71-16.68-.65-2.66,0-4.94.3-7.61-.26a93.62,93.62,0,0,0-11.19-2.17c-3.48-.3-7.2-1-10.67-1-3.06,0-4.6.2-7.32-1.7a.83.83,0,0,1-.07-1.17",
    transform: "translate(1216.38 1383.28)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.fc397fc53817e561a14d3dd7597005b1.svg";
export { ForwardRef as ReactComponent };